import Glide from '@glidejs/glide';
import 'core-js/es/array';

export default class Slider {

    constructor() {

        const sliders = Array.from(document.querySelectorAll('.glide'));

        let peekView = (window.innerWidth - 1082) / 2;

        if (!sliders.length) return;

        let sliderObj = {};

        sliders.forEach((slider, i) => {

            const clickableElements = Array.from(slider.querySelectorAll("a"));
            clickableElements.forEach((ele) =>
                ele.addEventListener("click", (e) => e.stopPropagation())
            );

            slider.addEventListener("click", (e) => {
                const sliderItem = event.target.closest('.c-lb__item');

                if (sliderItem) {
                    const anchor = sliderItem.querySelector("a");

                    if (anchor) {
                        anchor.click();
                    }
                }
            });

            let settings = {
                type: 'carousel',
                perView: 3,
                focusAt: 0,
                gap: 60,
                keyboard: false,
                breakpoints: {
                    1000: {
                        gap: 20
                    },
                    800: {
                        perView: 2,
                        gap: 20,
                    }
                }
            };
            const slidesLength = slider.dataset.itemsPerSlide;
            const disable = slider.dataset.disable;

            if(!isNaN(slidesLength)) {
                settings.perView = Number(slidesLength);
                settings.focusAt = 0;
            }
            // Add glide to the object for reference, disable global keyboard
            if (slider.id.includes('js-te-img')) {
                settings = {
                    type: 'slider',
                    perView: 1,
                    gap: 0,
                    keyboard: false,
                    direction: 'ltr',
                    rewind: false,
                    animationDuration: 500,
                    animationTimingFunc: 'ease-in-out',
                };
                sliderObj[i] = new Glide(slider, settings);
            }
            else if(slider.id.includes('js-te-text')){
                settings = {
                    type: 'slider',
                    perView: 1,
                    gap: 0,
                    startAt: 0,
                    keyboard: false,
                    direction: 'rtl',
                    rewind: false,
                    animationDuration: 500,
                    animationTimingFunc: 'ease-in-out',
                    breakpoints: {
                        800: {
                            direction: 'ltr'
                        }
                    }
                };
                sliderObj[i] = new Glide(slider, settings);
            }else if(slider.id.includes('js-in-slider')){

                settings = {
                    type: 'slider',
                    perView: 3,
                    keyboard: true,
                    gap: 32,
                    rewind: true,
                    swipeThreshold: 10,
                    touchRatio: 0.2,
                    animationDuration: 750,
                    breakpoints: {
                        800: {
                            perView: 1,
                            focusAt: 0,
                            gap: 16,
                        },
                        1334: {
                            perView: 3,
                            focusAt: 0,
                            gap: 16,

                        }
                    }
                };
                sliderObj[i] = new Glide(slider, settings);



            }else if(slider.id.includes('js-hero-slider')){

                settings = {
                    type: "slider",
                    gap: 20,
                    perView: 3,
                    keyboard: false,
                    rewind: false,
                    animationDuration: 200,
                    animationTimingFunc: 'ease-in-out',
                    peek: 0,
                    breakpoints:{

                        1280:{
                            gap: 20
                        },
                        950: {
                            perView: 2,
                            peek: 0,
                            gap: 16,
                        },
                        700: {
                            perView: 1,
                            peek: 0,
                        }
                    }
                }

                sliderObj[i] = new Glide(slider, settings);

            }

            else if (!window.matchMedia("(min-width: 1170px)").matches){
                return;
            }else{
                sliderObj[i] = new Glide(slider, settings);
            }

            // Attatch event listener and instruct slide to go left and right
            slider.addEventListener('keyup', (e) => {
                if (e.keyCode == 39) this.sliderObj[i].go('>');
                if (e.keyCode == 37) this.sliderObj[i].go('<');
            });

            const bulletCount = slider.querySelectorAll('.glide__slide').length;
            const bulletWrapper = slider.querySelector('.glide__bullets');

            if(slider.id.includes('js-in-slider')){
                for (let index = 0; index < bulletCount; index++) {
                    if(index % 3 === 0){
                        const button = document.createElement('button');
                        button.className = 'e-btn e-btn--bare glide__bullet';
                        button.setAttribute("data-glide-dir", '=' + index);
                        button.ariaLabel = `Go to slide ${index + 1}`;
                        if (bulletWrapper) {
                            bulletWrapper.appendChild(button);
                        }
                    }
                }

                let stringIndex = "=0";

                const sliderBullets = slider.querySelectorAll('.glide__bullet');

                sliderObj[i].on('run', () => {
                    let index = sliderObj[i].index;

                    stringIndex = "=" + index;

                    sliderBullets.forEach((bullet) => {

                        bullet.addEventListener('click', () => {

                            handleBullets(sliderBullets, stringIndex);

                        });

                    });
                });

                slider.querySelector(".glide__arrow--left").addEventListener('click', () => {
                    let slideIndex = sliderObj[i].index;

                    if(slideIndex - 3 < 0){
                        sliderObj[i].go("=0");
                        handleBullets(sliderBullets, stringIndex);
                    }else{
                        sliderObj[i].go(`=${slideIndex - 3}`);
                        handleBullets(sliderBullets, stringIndex);
                    }
                });


                sliderObj[i].on('run.after', () => {
                    handleBullets(sliderBullets, stringIndex);
                });

                slider.querySelector(".glide__arrow--right").addEventListener('click', () => {
                    let slideIndex = sliderObj[i].index;
                    if(slideIndex + 3 >= bulletCount){
                        sliderObj[i].go(`=${slideIndex}`);
                        handleBullets(sliderBullets, stringIndex);

                    }else{
                        sliderObj[i].go(`=${slideIndex + 3}`);
                        handleBullets(sliderBullets, stringIndex);
                    }
                });


            }else{
                for (let index = 0; index < bulletCount; index++) {
                    const button = document.createElement('button');
                    button.className = 'e-btn e-btn--bare glide__bullet';
                    button.setAttribute("data-glide-dir", '=' + index);
                    button.ariaLabel = `Go to slide ${index + 1}`;

                    if (bulletWrapper) {
                        bulletWrapper.appendChild(button);
                    }
                }
            }


            // Mount
            var slide = sliderObj[i].mount();

            if (disable === "True" || disable === "true") {
                // slide.disable();
            }
        });
        let testiGlide1, testiGlide2;

        for(let slider in sliderObj) {
            if(sliderObj[slider].selector.id.includes('js-te-img')) {
                testiGlide1 = sliderObj[slider];
            } else if(sliderObj[slider].selector.id.includes('js-te-text')) {
                testiGlide2 = sliderObj[slider];
            }
        }

        if(testiGlide2 && testiGlide1){

            let leftArrow = document.getElementById("js-te-left");
            let rightArrow = document.getElementById("js-te-right");
            let slideLength = document.getElementById(testiGlide2.selector.id).querySelectorAll(".glide__slide").length;
            toggleArrows(testiGlide2, leftArrow, rightArrow, slideLength)

            testiGlide1.on('run', (e) =>{
                testiGlide2.go(e.direction);
            });

            testiGlide2.on('run', (e) =>{
                if(e.direction == '='){
                    testiGlide1.go('=' + e.steps);
                }else{
                    testiGlide1.go(e.direction);
                }
                toggleArrows(testiGlide2, leftArrow, rightArrow, slideLength)
            });

            window.addEventListener("resize", () =>{
                toggleArrows(testiGlide2, leftArrow, rightArrow, slideLength)
            });

            let bulletText = document.getElementById("js-te-numbers");

            if(bulletText){
                let slides = Array.from(document.getElementById("js-te-text").querySelectorAll(".glide__slide"));

                bulletText.innerHTML = "1 / " + slides.length;

                testiGlide2.on('run', (e) =>{
                    if(e.direction === '>'){
                        bulletText.innerHTML = testiGlide2.index + 1 + " / " + slides.length;
                    } else {
                        bulletText.innerHTML = testiGlide2.index + 1 + " / " + slides.length;
                    }
                });
            }
        }

        window.addEventListener('resize', debounce(() => {
            sliders.forEach((slider, i) => {
            if (window.matchMedia("(min-width: 800px)").matches && !slider.id.includes("js-hero-slider") && !slider.id.includes("js-te-text") || slider.id.includes("js-te-img")) {
                if(sliderObj[i]){
                    sliderObj[i].enable();
                }
            }else if(slider.id.includes("js-hero-slider")){
                if(window.innerWidth < 950){
                    sliderObj[i].enable();
                }else{
                    sliderObj[i].disable();
                }
            }else if(slider.id.includes("js-te-text")){
                if(window.innerWidth < 800){
                    sliderObj[i].update({direction: "ltr"});
                }else{
                    sliderObj[i].update({direction: "rtl"});
                }
                if(sliderObj[i]){
                    sliderObj[i].enable();
                }
            }
            });
        }, 500));

    }

}

function debounce(func, time) {
  time = time || 100; // 100 by default if no param
  var timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}

function handleBullets(sliderBullets, stringIndex){
    sliderBullets.forEach((bullet) => {
        if (bullet.getAttribute('data-glide-dir') === stringIndex){
            bullet.classList.add("glide__bullet--active");
        } else{
            bullet.classList.remove("glide__bullet--active");
        }
    });
}

function toggleArrows(glide, leftArrow, rightArrow, slideLength){

    leftArrow.style.visibility = "visible";
    rightArrow.style.visibility = "visible";

    if(glide.index === 0){
        window.innerWidth < 800 ? leftArrow.style.visibility = "hidden" : rightArrow.style.visibility = "hidden"
    }else if(glide.index == slideLength - 1){
        window.innerWidth < 800 ? rightArrow.style.visibility = "hidden" : leftArrow.style.visibility = "hidden"
    }else{
        leftArrow.style.visibility = "visible";
        rightArrow.style.visibility = "visible";
    }
}